// Main authentication hook and provider
export { useWebAuthentication } from './useWebAuthentication'
export { WebAuthProvider, useWebAuthContext } from './WebAuthProvider'
export type {
  WebAuthState,
  WebAuthActions,
  MFAStatus,
} from './useWebAuthentication'

// Access permissions provider
export { AccessProvider, useProductAccess } from './AccessProvider'
export type { AccessPermissions } from './AccessProvider'

// MFA token management
export {
  useMFAToken,
  getMFATokenStandalone,
  clearMFATokenStandalone,
} from './useMFAToken'
export type { MFATokenStorage, MFATokenOperations } from './useMFAToken'

// Last visited organisation
export {
  useLastOrganisation,
  useRememberLastOrganisation,
} from './useLastOrganisation'
export type { LastOrganisationOperations } from './useLastOrganisation'

// MFA helpers and utilities
export { registerWebMFAInterceptors } from './mfaInterceptor'
export { setupWebMFAInterceptor } from './setupWebMFAInterceptor'
